import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const STATUS_LABEL = {
  pending: "Pending",
  confirmed: "Confirmed",
  preparing: "Preparing",
  out_for_delivery: "Out for delivery",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/orders/mine").then((r) => setOrders(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-16">
      <div className="overline">Your history</div>
      <h1 className="font-display text-4xl md:text-5xl mt-2">My Orders</h1>
      {loading ? (
        <div className="mt-16 text-[#6C665F]">Loading…</div>
      ) : orders.length === 0 ? (
        <div className="mt-16 text-[#6C665F]">You haven't placed any orders yet. <Link to="/shop/cakes" className="link-underline">Browse cakes →</Link></div>
      ) : (
        <div className="mt-8 space-y-4" data-testid="my-orders-list">
          {orders.map((o) => (
            <div key={o.id} className="card-eko p-5 flex flex-col md:flex-row md:items-center gap-4" data-testid={`order-${o.id}`}>
              <div className="flex-1">
                <div className="text-xs text-[#6C665F] font-mono">{o.id.slice(0, 8)}</div>
                <div className="font-display text-lg mt-1">{o.items.map((i) => i.name).join(", ")}</div>
                <div className="text-sm text-[#6C665F] mt-1">Delivery {o.delivery_date} · {o.delivery_slot}</div>
              </div>
              <div className="text-right">
                <div className="font-semibold">₹{o.total}</div>
                <div className="text-xs mt-1 inline-block px-3 py-1 rounded-full bg-[#F4F2EC]">{STATUS_LABEL[o.status]}</div>
                <div className="text-xs text-[#6C665F] mt-1">{o.payment_method === "cod" ? "COD" : o.payment_status === "paid" ? "Paid" : "Pending"}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
